import { useParams } from 'react-router-dom';
import getCurrentUser from 'hooks/getCurrentUser';
import { USER_ROLES } from 'constants/constants';

/**
 * Mirrors the backend's is_registry_admin: full-access (Analyst Institute staff) hold the
 * administrators role on the registry project, and platform superusers/staff always count.
 */
export default function useIsRegistryAdmin() {
  const { projectId } = useParams();
  const loggedInUser = getCurrentUser();
  const hasProjectAdminRole = loggedInUser.roles
    .filter((role) => role.partner_gcp_project_id === projectId)
    .some((role) => Number(role.level) === USER_ROLES.ADMIN.level);
  return hasProjectAdminRole || loggedInUser.is_superuser || loggedInUser.is_staff;
}
